var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttending(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24.216 22.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "attending_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.216v22.6H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#attending_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6.465a1.838 1.838 0 00-2.6.152L8.75 14.395 3.112 9.134a1.849 1.849 0 00-2.825 2.341L6.441 21.2a3.073 3.073 0 00.861.887 3.014 3.014 0 004.184-.813L23.9 2.867a1.839 1.839 0 00-.3-2.4",
    fill: "#2a848e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttending);
export default ForwardRef;